import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Navbar from "../components/Navbar.js";
import BackgroundAsImage from "components/hero/BackgroundAsImage.js";
import CategoryGallery from "components/cards/TabCardGrid";
import WelcomeRemark from "components/hero/TwoColumnWithFeaturesAndTestimonial.js";
import BuyForm from "components/TwoColBuyFormWithIllustrationFullForm.js";
import OurBenefits from "components/features/ThreeColWithSideImageWithPrimaryBackground.js";
import ContactUs from "components/forms/SimpleContactUs.js";
import Blog from "components/cards/ThreeColSlider.js";
import LatestNews from "components/news/LatestNews.js";
import TwoColumnWithImageAndProfilePictureReview from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import Subscribe from "components/forms/TwoColContactUsWithIllustration.js";
import Footer from "components/footers/FiveColumnDark.js";

const AgencyLandingPage = () => (
  <AnimationRevealPage disabled>
    <Navbar />
    <BackgroundAsImage />
    <CategoryGallery />
    <BuyForm />
    <OurBenefits />
    <TwoColumnWithImageAndProfilePictureReview />
    <WelcomeRemark />
    <Subscribe />
    <ContactUs />
    <Blog />
    <LatestNews />
    <Footer />
  </AnimationRevealPage>
);

export default AgencyLandingPage;
